export interface FaqItem {
  question: string;
  answer: string;
}

export const faqHeading = "Six fair questions, answered straight!";
export const faqIntro =
  "These are the questions people ask us privately, or don't ask and quietly decide against us. We would rather answer them in writing.";

export const faqs: FaqItem[] = [
  {
    question: "How is this different from the training that didn't change anything last time?",
    answer:
      "Most programs end when the session ends. Ours doesn't let go. Every week there is a bridgework assignment your manager has to complete with their own team and then report back on: a real conversation, a real decision, a real change. And a Development Pro follows up personally when someone goes quiet. The content is not the differentiator. The follow-up is.",
  },
  {
    question: "What stops my managers from ignoring this like they ignored the last one?",
    answer:
      "Three things. The sessions are live with a real facilitator. The assignment is done with their own team, so skipping it is a direct sign of poor leadership. And a Development Pro (real person) chases them. You will know within the first month who is engaging and who isn't. We report it.",
  },
  {
    question: "What will I actually be able to see in 90 days?",
    answer:
      "Attendance and completion by person. Which assignments came back and what your managers reported trying. Where a Development Pro had to intervene. Those are observable facts, not survey scores. We will also agree with you up front on one or two behaviors you want to see change, so there is something specific to judge us against.",
  },
  {
    question: "My managers say they have no time. Is that fair?",
    answer:
      "It is thirty minutes of live session a week, and about an hour a week once the reflection and the assignment are counted. Courses run two to five weeks. If an hour a week is genuinely not available, that is worth knowing. It is usually a signal about workload, and it will defeat any training program you buy, not just ours.",
  },
  {
    question: "How much of this lands on me and my HR team?",
    answer:
      "Very little by design. There is no curriculum to write, no facilitators to book, no LMS to stand up, and no chasing. Your real work is choosing who attends and staying in the loop with your Development Pro. If you are a team of one, that is the whole point of the model.",
  },
  {
    question: "What does it cost, and what am I locked into?",
    answer:
      "$349 per person per year for unlimited courses. Optional asynchronous coaching is $499 per person per year and you add it only for the people who need it. Billing is annual.",
  },
];
